import { FC } from 'react';

import { rem } from '@savgroup-front-common/primitive/helpers/units';

import Skeleton from './Skeleton';

const SkeletonAutocomplete: FC<{ highContrast?: boolean }> = ({
  highContrast = false,
}) => {
  return (
    <>
      <Skeleton
        height="18px"
        marginBottom={rem(7)}
        width="25%"
        highContrast={highContrast}
      />
      <Skeleton
        height="40px"
        marginBottom={rem(7)}
        highContrast={highContrast}
      />
    </>
  );
};

SkeletonAutocomplete.displayName = 'SkeletonAutocomplete';

export default SkeletonAutocomplete;
